var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgChartVector = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.25 25.9523C43.25 27.5195 41.9703 28.7856 40.3864 28.7856C38.8024 28.7856 37.5227 27.5195 37.5227 25.9523V6.11898C37.5227 4.55445 38.8024 3.28564 40.3864 3.28564C41.9703 3.28564 43.25 4.55445 43.25 6.11898V25.9523ZM26.0682 25.9523C26.0682 27.5195 24.7885 28.7856 23.2045 28.7856C21.6206 28.7856 20.3409 27.5195 20.3409 25.9523V11.7856C20.3409 10.2185 21.6206 8.95231 23.2045 8.95231C24.7885 8.95231 26.0682 10.2185 26.0682 11.7856V25.9523ZM17.4773 25.9523C17.4773 27.5195 16.1976 28.7856 14.6136 28.7856C13.0297 28.7856 11.75 27.5195 11.75 25.9523V20.2856C11.75 18.7185 13.0297 17.4523 14.6136 17.4523C16.1976 17.4523 17.4773 18.7185 17.4773 20.2856V25.9523ZM31.7955 14.619C33.3794 14.619 34.6591 15.8851 34.6591 17.4523V25.9523C34.6591 27.5195 33.3794 28.7856 31.7955 28.7856C30.2115 28.7856 28.9318 27.5195 28.9318 25.9523V17.4523C28.9318 15.8851 30.2115 14.619 31.7955 14.619Z",
    fill: "url(#paint0_linear_309_27629)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.3125 0.5C4.86553 0.5 6.125 1.74748 6.125 3.28571V32.5357C6.125 33.3018 6.7543 33.9286 7.53125 33.9286H42.6875C44.2432 33.9286 45.5 35.1734 45.5 36.7143C45.5 38.2551 44.2432 39.5 42.6875 39.5H7.53125C3.64824 39.5 0.5 36.3835 0.5 32.5357V3.28571C0.5 1.74748 1.75947 0.5 3.3125 0.5Z",
    fill: "url(#paint1_linear_309_27629)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_309_27629",
    x1: 27.5,
    y1: 3.28564,
    x2: 27.5,
    y2: 28.7856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_309_27629",
    x1: 23,
    y1: 0.5,
    x2: 23,
    y2: 39.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgChartVector);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chart-vector.8bc409371aa2f170f5a309688800e0c1.svg";